import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/native';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { View, Text, TextInput, Modal, Pressable } from 'react-native';

import {
  elRed,
  elGray
} from '../../styles/colors';

export {
  TabButtonContainer,
  TabButton,
} from 'app/src/components/Sellers/elements';

export const BuyersContainer = styled(View)`
  padding: 40px;
`;

export const ModalContainer = styled(Pressable)`

`;

export const BuyersShowContainer = styled(View)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const BuyerDemographicContainer = styled(View)`
  padding: 10px;
  max-width: 400px;
`;

export const ButtonContainer = styled(View)`

`;

export const BuyerAllAssetsContainer = styled(View)`
  width: 100%;
  border: 1px solid black;
  background-color: ${elGray};
  border-radius: 5px;
  height: fit-content;
  padding: 10px;
  margin-top: 20px;
`;

export const BuyerUsersContainer = styled(View)`
  width: 28%;
  border: 1px solid black;
  background-color: ${elGray};
  border-radius: 5px;
  padding: 10px;
`;

export const SectionCard = styled(View)`
  background-color: ${props => props.backgroundColor || 'white'};
  border-radius: 8px;
  border: 1px solid #ddd;
  padding: 20px;
  flex: 1 1 300px;
  min-width: 300px;
  max-width: 100%;
  box-sizing: border-box;
  margin-bottom: 20px;
  shadow-color: #000;
  shadow-opacity: 0.1;
  shadow-radius: 4px;
  elevation: 2;
`;

export const SectionHeader = styled(Text)`
  font-size: 18px;
  font-weight: bold;
  color: ${elRed};
  margin-bottom: 10px;
`;
